__turbopack_context__.v({
  "badge": "styles-module__tC3bGW__badge",
  "badgeLogo": "styles-module__tC3bGW__badgeLogo",
  "container": "styles-module__tC3bGW__container",
  "containerFillParent": "styles-module__tC3bGW__containerFillParent",
  "qrCode": "styles-module__tC3bGW__qrCode",
  "qrCodeFillParent": "styles-module__tC3bGW__qrCodeFillParent",
});
